import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const breadcrumbsDesignBreadcrumbsStyle1 = css`
  margin-bottom: ${theme.spacing(1)};
`;

export const BreadcrumbsStyles = {
  breadcrumbsDesignBreadcrumbsStyle1,
};
